import { Box, SvgIcon, Typography } from "@mui/material";
import React from "react";
import ReactComponent from "../assets/shi-square-logo.svg?react";

const ICON_FONT_SIZE = "24px";

export type ShiSpinnerIconSize = "small" | "medium" | "large";

const SIZE_MAP: Record<ShiSpinnerIconSize, string> = {
  small: "16px",
  medium: ICON_FONT_SIZE,
  large: "36px",
};

export function ShiSpinnerIcon({
  loadingText = "Loading...",
  size = "medium",
  fontSize,
}: {
  loadingText?: string;
  size?: ShiSpinnerIconSize;
  fontSize?: string;
}) {
  const resolvedFontSize = fontSize ?? SIZE_MAP[size];

  return (
    <Box
      display="flex"
      alignItems="center"
      role="status"
      aria-label={loadingText}
    >
      <SvgIcon
        style={{
          fontSize: resolvedFontSize,
          animation: "spin 1.2s linear infinite",
        }}
        component={ReactComponent}
        inheritViewBox
        aria-hidden
      />
      <Typography
        variant={"h6"}
        sx={{ ml: 1, fontSize: resolvedFontSize }}
        aria-hidden
      >
        {loadingText}
      </Typography>
    </Box>
  );
}
